module.exports = __webpack_public_path__ + "bg1.jpg?dcd23dccd85d9a659340468a8f3a8c3d";


//////////////////
// WEBPACK FOOTER
// ./dist/bg/bg1.jpg
// module id = 240
// module chunks = 0